import { render, staticRenderFns } from "./SummaryCashback.vue?vue&type=template&id=0cb43a30&"
import script from "./SummaryCashback.vue?vue&type=script&lang=js&"
export * from "./SummaryCashback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports